import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Button from '../Button/Button';
import TransitionGroup from './TransitionGroup';

class TransitionGroupExample extends Component {

  state = {
    timeout: 1000,
    className: 'fade-animation',
    in: false,
  };

  onChange = e => this.setState(e.target.value);

  onClick = () => {
    const { timeout } = this.state;

    this.setState({ in: !this.state.in });
    // force update of source code after toggle
    setTimeout(() => this.forceUpdate(), timeout + 500);
  };

  contentRenderer = () => {
    return (
      <p className="transition-paragraph">
        This is the dynamic content of the <code>TransitionGroup</code><br />
        and it will only show when the <em>in</em> prop is <strong>true</strong>,<br />
        and it will not be created until it is displayed.
      </p>
    );
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={TransitionGroup.defaultProps} propTypes={TransitionGroup.propTypes} propValues={this.state}>
          <Tip>Try the <strong>slide-animation</strong> transition for a different effect.</Tip>
        </Properties>
        <Button onClick={this.onClick}>{this.state.in ? 'Hide' : 'Show'}</Button>
        <TransitionGroup {...this.state}>
          <p className="transition-paragraph">
            This is the static content of a <code>TransitionGroup</code><br />
            and it will only show when the <em>in</em> prop is <strong>true</strong>,<br />
            but child element will be created by React every time.
          </p>
        </TransitionGroup>
        <TransitionGroup {...this.state} contentRenderer={this.contentRenderer} />
        <SourceCode querySelector=".transition-group-example .transition-paragraph" />
      </Example>
    );
  }

}

TransitionGroupExample.tags = 'animation';

export default TransitionGroupExample;
